import {useEffect, useState} from "react";
import {AuthContext} from "../context/Auth";
import Storage, {User} from "../common/StorageHelper";

const Provider = ({children}: { children: JSX.Element }) => {
    const [user, setUser] = useState<User | null>(Storage.getUser());

    useEffect(() => {
        if (user) {
            // console.log('user has changed', user)
        }
    }, [user])

    return (
        <AuthContext.Provider value={{
            setUser,
            user
        }}>
            {children}
        </AuthContext.Provider>
    );
}

export default Provider;
